import type { Action } from 'state/actions';
import * as addonActionTypes from 'state/addonForm/addonForm.actionTypes';
import { addOrPatchKey, removeKey, removeKeys } from 'state/utils/collection';

import type { PriceEnhancementsMap } from './priceEnhancements.model';

export function pricesEnhancementsReducer(state: PriceEnhancementsMap = {}, action: Action): PriceEnhancementsMap {
  switch (action.type) {
    case 'QUOTE_PRICE_ENHANCED':
    case addonActionTypes.ADDON_QUOTE_PRICE_ENHANCED:
      return addOrPatchKey(state, action.quoteId, previousState => ({ ...previousState, [action.key]: action.value }));
    case 'QUOTE_TRADE_SENT':
    case addonActionTypes.ADDON_QUOTE_TRADE_SENT:
    case addonActionTypes.ADDON_QUOTE_REMOVED:
      return removeKey(state, action.quoteId);
    case 'QUOTE_REMOVED':
      if (action.workspace !== 'static' && action.workspace !== 'dynamic') {
        return state;
      }
      return removeKey(state, action.quoteId);
    case 'QUOTES_REMOVED':
      return removeKeys(state, action.quoteIds);
    default:
      return state;
  }
}
